export function getBrowserTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function getUserTimezone(savedTimezone?: string): string {
  return savedTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
}
